export default "__VITE_ASSET__83ae821d__"